import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Alert, Button, Col, Modal, Row } from 'hljd'
import { HeaderView } from '@merchant-backend/common-components'
import CoverTemplate from './CoverTemplate'
import CoverPreview from './CoverPreview'
import style from './style.module.less'
import Store from './store'

@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }

  componentDidMount() {
    this.store.getCoverInfo()
  }

  renderVideoTipModal = () => {
    Modal.info({
      maskClosable: true,
      title: '修改视频尺寸攻略',
      width: 800,
      centered: true,
      content: (
        <video
          className={style['hlj-cut-video']}
          controls
          src="//qnm.hunliji.com/o_1cjkbr6a61gt31t3j1ij9vgv1d6o7.mp4"
        />
      ),
      onOk() {}
    })
  }

  render() {
    const {
      photo,
      video,
      changeCover,
      previewCover,
      isSaving,
      previewScene,
      materialInfo,
      approvalText,
      changeScene,
      saveCover
    } = this.store

    return (
      <HeaderView title="封面设置" className={style.container}>
        {approvalText && (
          <Alert
            className={style.alert}
            message={approvalText}
            type="warning"
            showIcon
          />
        )}
        <div className={style.body}>
          <Row>
            <Col span={14} className={style.rowLeft}>
              <Row>
                <Col span={5} className={style.title}>
                  <span className={style.must}>图片封面</span>
                </Col>
                <Col span={18}>
                  <p className={style.colNotice}>
                    请添加能展现店铺全貌的照片或视频，避免拍摄局部内容。画质清晰，色调明亮。
                  </p>
                  <CoverTemplate
                    scene={'photo'}
                    coverInfo={photo}
                    changeCover={changeCover}
                  />
                </Col>
              </Row>
              <Row className={style.mgt32}>
                <Col span={5} className={style.title}>
                  视频封面
                </Col>
                <Col span={18}>
                  <p className={style.colNotice}>
                    请上传 1
                    个视频，视频最大100M，支持RMVB、AVI、MP4等大部分主流视频格式；视频长宽建议为16:9.
                    <br />如何修改视频尺寸？
                    <a
                      href="javascript:;"
                      className={style.tipPoint}
                      onClick={this.renderVideoTipModal}
                    >
                      请点击这里查看攻略
                    </a>
                  </p>
                  <CoverTemplate
                    scene={'video'}
                    coverInfo={video}
                    changeCover={changeCover}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={10}>
              <CoverPreview
                previewCover={previewCover}
                previewScene={previewScene}
                materialInfo={materialInfo}
                changeScene={changeScene}
                store={this.store}
              />
            </Col>
          </Row>
        </div>

        <footer className={style.footerBtn}>
          <div>
            <Row>
              <Col span={14} className={style.rowLeft}>
                <Row>
                  <Col span={4} className={style.title} />
                  <Col span={18}>
                    <Button
                      type="primary"
                      loading={isSaving}
                      className={style.btn}
                      onClick={saveCover}
                    >
                      保存
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col span={10} />
            </Row>
          </div>
        </footer>
      </HeaderView>
    )
  }
}
